import { getPmSectionType, TYPE_PLACEMENT } from 'services/pm-section'
import { selectSectionsIds, selectReadyToRenderSections } from '../common'
import { sectionStatus } from '../../entities'

const getSectionsStatus = (sectionIds) => {
  if (sectionIds.isEmpty()) {
    return sectionStatus.EMPTY
  }
  return sectionStatus.READY
}

const isNotSpotlight = (sectionType) => sectionType !== TYPE_PLACEMENT

export function selectHomeSections (state) {
  const sectionIds = selectSectionsIds(state)
  const readySectionIds = selectReadyToRenderSections(state)
  const { pmSection } = state

  let rowPlacementCount = 0

  const sections = readySectionIds.map((sectionId) => {
    const sectionType = getPmSectionType({ pmSection, sectionId })
    let rowPlacement = null

    // This condition was requested by the data team since we were previously taking into
    // account the Spotlight but, they wanted to ignore this row for GA work related.
    if (isNotSpotlight(sectionType)) {
      rowPlacement = rowPlacementCount
      rowPlacementCount += 1
    }
    return {
      sectionId,
      rowPlacement,
      sectionType,
    }
  })

  const status = getSectionsStatus(sectionIds, readySectionIds)

  return {
    status,
    items: sections,
  }
}

export default selectHomeSections
